import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "components/Layout";
import Home from "pages/home/Home";
import About from "pages/about/About";
import Organization from "pages/about/Organization";
// n소식 목록
import News from "pages/news/News";
// n소식 상세
import NoticeEdit from "pages/news/NoticeEdit";
import Business from "pages/business/Business";
import BusinessDetail from "pages/business/BusinessDetail";
import Recruitment from "pages/recruitment/Recruitment";

import Login from "pages/admin/Login";
import Login2 from "pages/admin/Login2";
import Pst from 'pages/admin/Pst';
import PstEdit from "pages/admin/PstEdit";
import Account from "pages/admin/Account";
import Mypage from "pages/admin/Mypage";

import PrivateRoute from "components/PrivateRoute"; // PrivateRoute 컴포넌트 가져오기

// 부트스트랩 연결
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    {/* 기업소개 */}
                    <Route path="about" element={<About />} />
                    <Route path="about/organization/:aboutId" element={<Organization />} />
                    {/* N 소식 */}
                    <Route path="news" element={<News />} />
                    <Route path="news/:id" element={<NoticeEdit />} />
                    {/* 비즈니스 */}
                    <Route path="business" element={<Business/>} />
                    <Route path="business/:id" element={<BusinessDetail/>} />
                    {/* 인재채용 */}
                    <Route path="recruitment" element={<Recruitment/>} />
                    {/* 관리자메뉴 */}
                    {/* 로그인 */}
                    <Route path="system" element={<Login />} />
                    <Route path="system2" element={<Login2 />} />
                    {/* 계정관리 */}
                    <Route path="account" element={<PrivateRoute><Account /></PrivateRoute>} />
                    <Route path="mypage" element={<PrivateRoute><Mypage /></PrivateRoute>} />
                    {/* 게시글관리 */}
                    <Route path="psts" element={<PrivateRoute><Pst /></PrivateRoute>} />
                    <Route path="pst" element={<PrivateRoute><PstEdit /></PrivateRoute>} />
                    <Route path="pst/:pstId" element={<PrivateRoute><PstEdit /></PrivateRoute>} />

                </Route>
            </Routes>
        </Router>
    );
}

export default App;